import React from 'react';
import './styles/Divider.css';

const Divider = (props) => {
    let prefix = 'divider--';

    return (
        <div className={`divider ${prefix + props.color} ${prefix + props.type}`} />
    )
};

export default Divider;